import { machines } from '../machines/machines-sidecar'
import { scene } from '../main/scene-sidecar'
import { tilesDataShip } from '../tiles/tilesDataShip-sidecar'
import { addCargoToStack } from './testRig_common'
import { testRig_common } from './testRig_common-sidecar'
import { testRig_escapeShuttle } from './testRig_escapeShuttle-sidecar'
import { monsters } from '../monsters/monsters-sidecar'
import { monsterSelector } from '../ui/monsterSelector-sidecar'
import { generatorAsteroids } from '../generators/generatorAsteroids-sidecar'

export const createTestRig_mineAsteroid = (x: number, y: number) => {
  let ctx = scene.getContext()

  testRig_escapeShuttle.createTestRig_escapeShuttle(x, y)

  let m = monsters.create('human', 1)
  monsters.moveToTile(m, ctx.mapShip, x + 2 + 6 - 3, y + 2)
  m.isInsideShip = true
  monsters.setInSuit(m, false)
  monsterSelector.select(m)

  generatorAsteroids.generateBigAsteroid(30, 10)
}
